<template>
  <ButtonSquare
    :title="t('general__text_panoramic')"
    :imgSource="iconPanoramaView"
    size="large"
    :activeState="activeState"
    :showLoadingSpinner="isLoading"
    @clicked="onClick"
    @mouseenter="onHover"
  />
</template>

<script lang="ts" setup>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { computed, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { getFileBlobv2 } from '@/services/files.service'
import { useI18n } from 'vue-i18n'
import iconPanoramaView from '@/assets/icons-general/icon-panorama-view.svg'

const { t } = useI18n()
const store = useStore()
interface EMITS {
  (e: 'PanoramaViewButtonHovered')
}
const emits = defineEmits<EMITS>()

const showOverlayModal = computed(() => store.state.showOverlayModal)
const selectedRoom = computed(() => store.state.selectedRoom)

const activeState = computed(() => {
  if (!selectedRoom.value || selectedRoom.value.properties.panoramaImages.length === 0)
    return 'deactivated'
  return isButtonActive.value ? 'active' : 'inactive'
})

let isLoading = ref(false)

let fileAborter = ref<AbortController | null>(null)
let isButtonActive = ref(false)
watch(showOverlayModal, () => {
  if (!showOverlayModal.value) isButtonActive.value = false
})

watch(selectedRoom, (newRoom, OldRoom) => {
  if (!selectedRoom.value || newRoom !== OldRoom) {
    if (fileAborter.value) {
      fileAborter.value.abort()
      isButtonActive.value = false
    }
  }
})

function onHover() {
  if (activeState.value !== 'deactivated') {
    emits('PanoramaViewButtonHovered')
  }
}
async function onClick() {
  if (activeState.value === 'deactivated') return
  isButtonActive.value = !isButtonActive.value
  if (fileAborter.value) fileAborter.value.abort()
  if (activeState.value !== 'active') return
  fileAborter.value = new AbortController()
  isLoading.value = true
  try {
    const endpoint = `/documents/${selectedRoom.value.properties.panoramaImages[0].file.storageFileName}`
    const res = await getFileBlobv2(endpoint, fileAborter.value.signal)
    if (!res) throw 'canceled'
    const url = window.URL.createObjectURL(res?.data)
    store.commit('SET_CURRENT_PANORAMA_URL', url)
    store.commit('SET_STATUS_ON_SHOW_OVERLAY_MODAL', { toggleModal: true })
    isLoading.value = false
    store.commit('SET_CURRENT_OVERLAY_MODAL', { modalName: 'panoramavy' })
  } catch (e) {
    if (e === 'canceled') isLoading.value = false
    return
  }
}
</script>
